import React, { useState } from "react";
import { Auth } from "aws-amplify";
import { useHistory, useLocation, Link } from "react-router-dom";
import Form from "react-bootstrap/Form";
import LoaderButton from "../components/LoaderButton";
import { BsCheck } from "react-icons/bs";
import { useAppContext } from "../libs/contextLib";
import { useFormFields } from "../libs/hooksLib";
import { onError } from "../libs/errorLib";
import admins from "../admins";
import "./Login.css";

export default function ResetPassword() {
  const history = useHistory();
  const { userHasAuthenticated, userProfile, setUserProfile, setIsAdmin } = useAppContext();
  const [isLoading, setIsLoading] = useState(false);

  const [codeSent, setCodeSent] = useState(false);
  const [confirmed, setConfirmed] = useState(false);
  const [isConfirming, setIsConfirming] = useState(false);
  const [isSendingCode, setIsSendingCode] = useState(false);
  const [headerTitle, setHeaderTitle] = useState("パスワードリセット画面");

  const [fields, messages, handleFieldChange, doValidation] = useFormFields({
    code: "",
    loginId: "",
    password: "",
    confirmPassword: ""
  },
  {
    code: {n:"", f: (value) => { console.log(value); return '' }},
    loginId: {n:"", f: (value) => { console.log(value); return '' }},
    password: {n:"", f: (value) => { console.log(value); return '' }},
    confirmPassword: {n:"", f: (value) => { console.log(value); return '' }}
  });

  function validateCodeForm() {
    return fields.loginId.length > 0;
  }

  function validateResetForm() {
    return (
      fields.code.length > 0 &&
      fields.password.length > 0 &&
      fields.password === fields.confirmPassword
    );
  }

  async function handleConfirmClick(event) {
    event.preventDefault();

    setIsConfirming(true);

    try {
      await Auth.forgotPasswordSubmit(
        fields.loginId,
        fields.code,
        fields.password
      );
      setConfirmed(true);
      setHeaderTitle('パスワードリセット完了');
    } catch (error) {
      onError(error);
      setIsConfirming(false);
    }
  }

  async function handleSendCodeClick(event) {
    event.preventDefault();

    setIsSendingCode(true);
    console.log(fields.loginID);
    try {
      await Auth.forgotPassword(fields.loginId);
      setCodeSent(true);
    } catch (error) {
      onError(error);
      setIsSendingCode(false);
    }
  }

  function renderRequestCodeForm() {
    return (
      <>
      <p>ログインID（会員番号）を入力して「確認コード送信」ボタンをクリックしてください。<br/>
会員番号は先頭から0（ゼロ）を追加して６桁を入力してください。<br/>
（例：会員番号1111→001111を入力）
</p>
      <Form onSubmit={handleSendCodeClick}>
        <Form.Group size="lg" controlId="loginId">
          <Form.Label>ログインID（会員番号）</Form.Label>
          <Form.Control
            autoFocus
            type="text"
            value={fields.loginId}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <LoaderButton
          block
          type="submit"
          size="lg"
          isLoading={isSendingCode}
          disabled={!validateCodeForm()}
        >
          確認コード送信
        </LoaderButton>
      </Form>
      </>
    );
  }

  function renderConfirmationForm() {
    return (
        <>
          <p>
            確認コードは登録のメールアドレスに送信しました。
          </p>
          <ol className="confirmaitonCodeCautions">
            <li>パスワードに使用できる文字は、半角の英字すべて・半角の数字すべてです。</li>
            <li>パスワードには、英字・数字それぞれ最低１文字ずつ含む必要があります。</li>
            <li>パスワードの長さは、半角8文字以上から半角30文字以下です。</li>
            <li>変更前のパスワードと同じパスワードは設定できません。</li>

          </ol>
      <Form onSubmit={handleConfirmClick}>
        <Form.Group size="lg" controlId="code">
          <Form.Label>確認コード</Form.Label>
          <Form.Control
            autoFocus
            type="tel"
            value={fields.code}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <hr />
        <Form.Group size="lg" controlId="password">
          <Form.Label>新しいパスワード</Form.Label>
          <Form.Control
            type="password"
            value={fields.password}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <Form.Group size="lg" controlId="confirmPassword">
          <Form.Label>新しいパスワード（確認）</Form.Label>
          <Form.Control
            type="password"
            value={fields.confirmPassword}
            onChange={handleFieldChange}
          />
        </Form.Group>
        <LoaderButton
          block
          type="submit"
          size="lg"
          isLoading={isConfirming}
          disabled={!validateResetForm()}
        >
          パスワード変更
        </LoaderButton>
      </Form>
      </>
    );
  }

  function renderSuccessMessage() {
    return (
      <div className="success">
        <p>パスワードがリセットされました。</p>
        <p>
          <Link to="/login">
            ログイン画面
          </Link>
            より新しいパスワードでログインしてください。
        </p>
      </div>
    );
  }


  return (
    <div className="Login">

      <h1 id="page_title">{headerTitle}</h1> 
      <div id="sub_page">
      <div id="mypage" className="login">
      <section>
	  {!codeSent 
            ? renderRequestCodeForm()
           : !confirmed
           ? renderConfirmationForm()
           : renderSuccessMessage() }
      </section>
      </div>
      </div>
    </div>
  );
}
